import {styled} from "@mui/material";
import Button from "@mui/material/Button";

export const SamaggiButton = styled(Button)<{ colour?: string, hoverColour?: string, noPad?: boolean }>(({colour = "#00292c", hoverColour = "#012025", noPad = false
}) => ({
    backgroundColor: colour,
    color: "#FFFFFF",
    fontWeight: "600",
    borderRadius: "10px",
    height: "45px",
    padding: noPad? "0" : "initial",
    fontSize: "26px",
    borderWidth: "1px",
    borderColor: "#222222",
    boxShadow: "0 1px 3px #9E9E9E",
    "&:hover": {
        backgroundColor: hoverColour
    },
    "&:disabled": {
        backgroundColor: "rgb(150, 150, 150)"
    }
}))